export default class ComputationData {
    constructor(id, voyageId, voyageTheyrId, stateValue, stateTitle, progress, computation, date) {
        this.id = id
        this.voyageId = voyageId
        this.voyageTheyrId = voyageTheyrId
        this.stateValue = stateValue
        this.stateTitle = stateTitle
        this.progress = progress
        this.computation = computation
        this.date = date
    }

    get computationDate() {
        return this.date.toLocaleDateString("en-GB")
    }

    get computationTime() {
        return this.date.toLocaleTimeString("en-GB", { hour: '2-digit', minute: '2-digit' });
    }

}